import { render, staticRenderFns } from "./CultureAssetBaseClass.vue?vue&type=template&id=67ae9250&scoped=true&"
import script from "./CultureAssetBaseClass.vue?vue&type=script&lang=js&"
export * from "./CultureAssetBaseClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ae9250",
  null
  
)

export default component.exports